import PropTypes from 'prop-types';

HeroPageLayout.propTypes = {
  children: PropTypes.node,
};

export default function HeroPageLayout({ children }) {
  return (
    <div className="min-h-screen-nav lg:px-3 flex-grow bg-base-200 h-full overflow-x-hidden max-h-full">
      <div className="pt-5 pb-10 flex-col lg:flex-row items-start  relative">
        {children}
      </div>
    </div>
  );
}
